export const providerBetLimitTableHead = [
  { name: '#' },
  { name: 'ID' },
  { name: 'Min - Max' },
  { name: 'Reference' },
  { name: '' },
];
